import BaseService from "../base.service";
//import http from "../../http-common";

class TaskService extends BaseService {
  constructor() {
    super("tasks");
  }
}

export const Task = new TaskService();